import { defineMessages } from 'react-intl';

export default defineMessages({
  congratulations: 'Congrats!',
  transactionDetails:
    'These are your transaction details. Make sure to check if this is correct before submitting.',
  successfullyExecuted: 'Your action has been successfully executed',
  nextSteps: 'Next steps',
  approve: 'Approve',
  goBack: 'Go back',

  checkboxText: 'Don’t ask me to approve again',
  goToDashboard: 'Go to dashboard',
  submit: 'Submit',

  errorTitle: 'Something went wrong',
  errorDescription:
    'It is not possible to complete the transaction at the moment, please try again later.',
  txFailReason: 'Transaction failed with the reason: {reason}',
});
